import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    console.log(currentPage,"currentx")
    console.log(totalPages,"totalPages")
  // Don't render the pagination if there is only one page
  if (totalPages <= 1) {
    return null;
  }

  const maxVisiblePages = 5; // Maximum number of visible pages before showing ellipsis
  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  // Calculate the start and end index for the visible page numbers
  const startIndex = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
  const endIndex = Math.min(startIndex + maxVisiblePages - 1, totalPages);

  return (
    <nav>
      <ul className='pagitnations' style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
        {/* Hide "Previous" button on the first page */}
        {currentPage > 1 && (
          <li style={{ margin: '0.25rem' }}>
            <button
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '9999px',
                color: '#3b82f6',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#dbeafe',
                  color: '#2563eb',
                },
              }}
              onClick={() => onPageChange(currentPage - 1)}>
              Previous
            </button>
          </li>
        )}

        {startIndex > 1 && (
          <li style={{ margin: '0.25rem' }}>
            <button
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '9999px',
                color: '#6b7280',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#dbeafe',
                  color: '#2563eb',
                },
              }}
              onClick={() => onPageChange(1)}>
              1
            </button>
          </li>
        )}

        {startIndex > 1 && (
          <li style={{ margin: '0.25rem' }}>
            <span style={{ padding: '0.5rem 1rem' }}>...</span>
          </li>
        )}

        {pageNumbers.slice(startIndex - 1, endIndex).map((pageNumber) => (
          <li
            key={pageNumber}
            style={{ margin: '0.25rem' }}
            onClick={() => onPageChange(pageNumber)}>
            <button
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: currentPage === pageNumber ? '#f87171' : 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '9999px',
                color: currentPage === pageNumber ? 'white' : '#6b7280',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#dbeafe',
                  color: '#2563eb',
                },
              }}>
              {pageNumber}
            </button>
          </li>
        ))}

        {endIndex < totalPages && (
          <li style={{ margin: '0.25rem' }}>
            <span style={{ padding: '0.5rem 1rem' }}>...</span>
          </li>
        )}

        {endIndex < totalPages && (
          <li style={{ margin: '0.25rem' }}>
            <button
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '9999px',
                color: '#6b7280',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#dbeafe',
                  color: '#2563eb',
                },
              }}
              onClick={() => onPageChange(totalPages)}>
              {totalPages}
            </button>
          </li>
        )}

        {/* Hide "Next" button on the last page */}
        {currentPage < totalPages && (
          <li style={{ margin: '0.25rem' }}>
            <button
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '9999px',
                color: '#3b82f6',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#dbeafe',
                  color: '#2563eb',
                },
              }}
              onClick={() => onPageChange(currentPage + 1)}>
              Next
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
